import { IconProps } from "./Icons";

export const IconFirstAidKit = ({ width = 24, height = 24 }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
  >
    <g filter="url(#filter0_i_4501_2826)">
      <path
        d="M20.25 5.9082H16.5V5.1582C16.5 4.56147 16.2629 3.98917 15.841 3.56721C15.419 3.14526 14.8467 2.9082 14.25 2.9082H9.75C9.15326 2.9082 8.58097 3.14526 8.15901 3.56721C7.73705 3.98917 7.5 4.56147 7.5 5.1582V5.9082H3.75C3.35218 5.9082 2.97064 6.06624 2.68934 6.34754C2.40804 6.62885 2.25 7.01038 2.25 7.4082V19.4082C2.25 19.806 2.40804 20.1876 2.68934 20.4689C2.97064 20.7502 3.35218 20.9082 3.75 20.9082H20.25C20.6478 20.9082 21.0294 20.7502 21.3107 20.4689C21.592 20.1876 21.75 19.806 21.75 19.4082V7.4082C21.75 7.01038 21.592 6.62885 21.3107 6.34754C21.0294 6.06624 20.6478 5.9082 20.25 5.9082ZM9 5.1582C9 4.95929 9.07902 4.76853 9.21967 4.62787C9.36032 4.48722 9.55109 4.4082 9.75 4.4082H14.25C14.4489 4.4082 14.6397 4.48722 14.7803 4.62787C14.921 4.76853 15 4.95929 15 5.1582V5.9082H9V5.1582ZM20.25 19.4082H3.75V7.4082H20.25V19.4082ZM15 13.4082C15 13.6071 14.921 13.7979 14.7803 13.9385C14.6397 14.0792 14.4489 14.1582 14.25 14.1582H12.75V15.6582C12.75 15.8571 12.671 16.0479 12.5303 16.1885C12.3897 16.3292 12.1989 16.4082 12 16.4082C11.8011 16.4082 11.6103 16.3292 11.4697 16.1885C11.329 16.0479 11.25 15.8571 11.25 15.6582V14.1582H9.75C9.55109 14.1582 9.36032 14.0792 9.21967 13.9385C9.07902 13.7979 9 13.6071 9 13.4082C9 13.2093 9.07902 13.0185 9.21967 12.8779C9.36032 12.7372 9.55109 12.6582 9.75 12.6582H11.25V11.1582C11.25 10.9593 11.329 10.7685 11.4697 10.6279C11.6103 10.4872 11.8011 10.4082 12 10.4082C12.1989 10.4082 12.3897 10.4872 12.5303 10.6279C12.671 10.7685 12.75 10.9593 12.75 11.1582V12.6582H14.25C14.4489 12.6582 14.6397 12.7372 14.7803 12.8779C14.921 13.0185 15 13.2093 15 13.4082Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_4501_2826"
        x="0"
        y="0.658203"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="122" dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_4501_2826"
        />
      </filter>
    </defs>
  </svg>
);
